/* eslint-disable */
import moment from 'moment';
import 'moment/locale/ru';

import CheckInDateRangeFactory from "@/js/common/Domain/Factory/CheckInDateRange";
import gaAsync from "@/js/common/Domain/Service/gaAsync";
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";

let CheckInDateRangeView = Backbone.View.extend({
	label: 'Дата вылета',
	$dateInput: function () {
		this.$dateInput = $('.date', this.$el);
	},
	scrollToElement: function (e) {
		var currenPosition = $(document).scrollTop(),
			windowHeight = $(window).height(),
			headerHeight = $('.headerContainer').height(),
			menuHeight = $('.menuContainer').height(),
			elementPosition = this.$dateInput.offset().top,
			self = this,
			scrollTo;

		scrollTo = elementPosition;

		headerHeight ? scrollTo -= headerHeight : '';
		menuHeight ? scrollTo -= menuHeight : '';

		scrollTo -= 50;

		setTimeout(function () {
			self.showDropdown(self.$el);
		}, 1);

		if (elementPosition > currenPosition + windowHeight || elementPosition < currenPosition) {
			$("html, body").animate({scrollTop: scrollTo}, 200);
			return true;
		}

		return false;
	},
	dateFromOld: null,
	dateToOld: null,
	departureCityData: null,
	$nightRangeEl: null,
	daysRange: null,
	gaTime: 0,
	gaTimer: null,
	enableCloseTimeout: false,
	$dateFlexibleCheckbox: function () {
		this.$dateFlexibleCheckbox = $('#dateFlexible');
	},
	$daysFlexible: function () {
		this.$daysFlexible = $('#daysFlexible');
	},
	getDatepicker: function () {
		return $('#dateRangeContainer');
	},
	hideDropdown: function ($element) {
		var self = this;
		$element.parents('.formControl').find('.formDropdownContent:visible').hide();
		$element.parents('.formControl').find('.formInput.open').removeClass('open');
		clearInterval(self.gaTimer);
	},
	showDropdown: function ($element) {
		var self = this;
		$element.parents('.formControl').find('.formDropdownContent:hidden').show();
		$element.parents('.formControl').find('.formInput').addClass('open');
		clearInterval(self.gaTimer);
		this.dataLayerAnalyticsEvent();
	},
	dataLayerAnalyticsEvent(){
		if(this.dataLayerAnalytics){
			this.dataLayerAnalytics.searchFieldsEvent('datesOpen')
		}
	},
	chooseCalendarNumber: function () {
		var windowWidth = $(window).width(),
			numOfCalendars = 2;

		if (windowWidth < 705) {
			numOfCalendars = 1;
		}

		return numOfCalendars;
	},
	datepickerParams: function (self, closed) {
		return {
			numberOfMonths: this.chooseCalendarNumber(),
			minDate: '+1d',
			maxDate: '+1y',
			dateFormat: "dd.mm"
		};
	},
	getMiddleDate: function (checkInDateRange) {
		var middleDate,

			checkInDateRangeFrom = checkInDateRange.get('from'),
			checkInDateRangeTo = checkInDateRange.get('to'),
			dateDiff = moment(checkInDateRangeTo).diff(checkInDateRangeFrom, 'days');

		middleDate = moment(checkInDateRangeFrom).clone().add(dateDiff / 2, 'days').toDate();

		return middleDate;
	},
	datePickerSetDate: function (checkInDateRange) {
		var self = this,
			middleDate = this.getMiddleDate(checkInDateRange),
			departureCityData = this.departureCityData.get('model'),
			daysRange = departureCityData ? departureCityData.get('daysRange') : 3,
			checkInDateRangeFrom = checkInDateRange.get('from'),
			checkInDateRangeTo = checkInDateRange.get('to');

		if (checkInDateRangeFrom.getTime() !== checkInDateRangeTo.getTime()) {
			self.$dateFlexibleCheckbox.prop('checked', true);
			self.daysRange = daysRange;
		} else {
			self.$dateFlexibleCheckbox.prop('checked', false);
			self.daysRange = 0;
		}

		this.$daysFlexible.text(daysRange + ' ' + daysRange.wordEnding('день;дня;дней'));
		this.getDatepicker().datepicker("setDate", middleDate);

		this.updateDateText();
	},
	updateDateText: function () {
		var datesText,
			checkInDateRange = this.model.get('model'),
			dateFrom = checkInDateRange.get('from'),
			dateTo = checkInDateRange.get('to'),
			departureCityData = this.departureCityData.get('model'),
			daysRange = departureCityData ? departureCityData.get('daysRange') : 3,
			middleDate;

		if (dateFrom.getTime() !== dateTo.getTime()) {
			if (moment(dateTo).diff(moment(dateFrom), 'days') == daysRange * 2) {
				middleDate = this.getMiddleDate(checkInDateRange);
				datesText = "с " + moment(middleDate).format('DD.MM') + ' ± ' + daysRange + ' ' + daysRange.wordEnding('день;дня;дней');
			} else {
				datesText = 'c ' + moment(dateFrom).format('DD.MM') + ' по ' + moment(dateTo).format('DD.MM');
			}
		} else {
			datesText = "с " + moment(dateFrom).format('DD.MM.YYYY');
		}

		this.$dateInput.val(datesText);
	},
	datePickerChooseDate: function () {
		var datepickerDate = this.getDatepicker().datepicker("getDate");

		this.datesChanged(datepickerDate);
	},
	otherSourceDataChanged: function () {
		var middleDate,
			checkInDateRange = this.model.get('model');

		if (checkInDateRange) {
			middleDate = this.getMiddleDate(checkInDateRange);
			this.datesChanged(middleDate);
		}
	},
	datesChanged: function (date) {
		var departureCityData = this.departureCityData.get('model'),
			daysRange = departureCityData ? departureCityData.get('daysRange') : 3,
			daysRangeSelected = this.$dateFlexibleCheckbox.is(':checked'),
			self = this;

		if (daysRangeSelected) {
			var checkInDateRange = CheckInDateRangeFactory({
				from: date,
				daysFlexible: daysRange
			});

			self.daysRange = daysRange;
		} else {
			var checkInDateRange = CheckInDateRangeFactory({
				from: date,
				to: date
			});

			self.daysRange = 0;
		}

		if (checkInDateRange && checkInDateRange.get('from') && checkInDateRange.get('to')) {

			var departureVal = '';
			if (self.dateFromOld === null) {
				self.dateFromOld = checkInDateRange.get('from')
			}

			if (self.dateToOld === null) {
				self.dateToOld = checkInDateRange.get('to');
			}
			if (self.dateFromOld.getTime() != checkInDateRange.get('from').getTime()) {
				self.dateFromOld = checkInDateRange.get('from');
				departureVal += "c " + moment(self.dateFromOld).format('DD.MM');
			}
			if (self.dateToOld.getTime() != checkInDateRange.get('to').getTime()) {
				self.dateToOld = checkInDateRange.get('to');
				if (departureVal.length) departureVal += ' ';
				departureVal += "по " + moment(self.dateToOld).format('DD.MM');
			}
			if (departureVal.length) {
				if (departureVal.length) {
					if (document.location.pathname == "/") {
						gaAsync(function () {
							ga('send', 'event', 'Search form main', 'Departure_from_to', departureVal, {'nonInteraction': 1})
						});
					} else {
						gaAsync(function () {
							ga('send', 'event', 'Search form serp', 'Departure_from_to', departureVal, {'nonInteraction': 1})
						});
					}
				}
			}

			this.$daysFlexible.text(daysRange + ' ' + daysRange.wordEnding('день;дня;дней'));
			this.model.set('model', checkInDateRange, {initiator: 'view'});

			this.updateDateText();
			this.getDatepicker().datepicker("refresh");

			console.log(date, daysRange, daysRangeSelected);
			console.log('Changed CheckInDateRange to' + checkInDateRange.get('from') + '-' + checkInDateRange.get('to'));
		} else {
			console.log(date, daysRange, daysRangeSelected);
			// TrackJS.track("Wrong date from datepicker");
		}
	},
	openNights: function (e) {
		this.hideDropdown(this.$el);
		this.$nightRangeEl.addClass('open');
	},
	dateRangeInit: function () {
		var self = this,
			datepickerParams = this.datepickerParams(this);

		this.getDatepicker().datepicker(datepickerParams)
			.bind('change', function (e) {
				tourCriteriaService.addTourCriteriaChangedField('checkInDateRange');
				self.datePickerChooseDate.call(self);
				self.openNights(e);
			});

		this.$dateFlexibleCheckbox.on('change', function () {
			tourCriteriaService.addTourCriteriaChangedField('checkInDateRange');
			self.otherSourceDataChanged.call(self);
		});

		this.$dateInput.parents('.formInput').click(function () {
			if (!self.$el.hasClass('disable')) {
				if ($(this).hasClass("open")) {
					self.hideDropdown($(this));
				} else {
					self.showDropdown($(this));
				}
			}
		});

		$(document).click(function (event) {
			if (!($(event.target).parents('.tour-duration').length
				|| $(event.target).parents('.ui-datepicker').length
				|| $(event.target).hasClass('ui-datepicker-prev')
				|| $(event.target).hasClass('ui-datepicker-next')
				|| $(event.target).parent().hasClass('ui-datepicker-prev')
				|| $(event.target).parent().hasClass('ui-datepicker-next')
			)) {
				self.hideDropdown(self.$el);
			}
		});
	},
	modelChanged: function (event, model, context) {
		if (!context || context.initiator !== 'view') {
			if (model === null) {
				this.$el.addClass('disable');
			} else {
				this.$el.removeClass('disable');
				this.datePickerSetDate(model);
			}
		}
	},
	departureCityChanged: function (event, model, context) {
		console.log('departureCityChanged', event, model, context);
	},
	initEvents: function () {
		this.model.on('change:model', $.proxy(this.modelChanged, this));
		this.departureCityData.on('change:model', $.proxy(this.otherSourceDataChanged, this));
	},
	initialize: function (options) {
		var self = this;

		this.$dateInput();

		this.departureCityData = options.departureCityData;
		this.$nightRangeEl = $(options.nightRangeEl);
		this.dataLayerAnalytics = options.dataLayerAnalytics;
		this.$dateFlexibleCheckbox();
		this.$daysFlexible();
		this.initEvents();
		this.dateRangeInit();
	}
});

export default CheckInDateRangeView;
